import { KeyPairs, ReponseActionApi } from '../../core/shared/core.models';

export class UtilisateurIdz {
  nom: string;
  code: string;
  claims: Array<KeyPairs>;
}

export class ReponseActionApiAuth extends ReponseActionApi<any> {
  nom: string;
  code: string;
  claims: any;
  estAuthentifie: boolean;
  url: string;
}
